import { cn } from "@/lib/utils"
import { BorderBeam } from "@/components/ui/border-beam"

interface GlassCardProps {
  children: React.ReactNode
  className?: string
  beam?: boolean
  beamColorFrom?: string
  beamColorTo?: string
}

export function GlassCard({
  children,
  className,
  beam = false,
  beamColorFrom,
  beamColorTo,
}: GlassCardProps) {
  return (
    <div className={cn("relative rounded-lg glass-card p-6", className)}>
      {children}
      {beam && (
        <BorderBeam
          size={120}
          duration={8}
          colorFrom={beamColorFrom ?? "#3b82f6"}
          colorTo={beamColorTo ?? "#8b5cf6"}
        />
      )}
    </div>
  )
}
